import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { foCaAnApi } from "../../../api/dich-vu/food/foCaAnApi";
import { foCaAnTruongApi } from "../../../api/dich-vu/food/foCaAnTruongApi";
import { IBaseResponeModel } from "../../../models/response/base-response";
import {
	eFoCaAnTruongActionTypeIds,
	IFoCaAnTruongDeleteStart,
	IFoCaAnTruongLoadStart,
	IFoCaAnTruongSaveStart
} from "../../action-types/dich-vu/IFoCaAnTruongActionTypes";
import { foCaAnTruongActions } from "../../actions/dich-vu/foCaAnTruongActions";

export function* foCaAnTruongSaga(): any {
	yield takeLatest(eFoCaAnTruongActionTypeIds.LOAD_START, loadFoCaAnTruongWorker)
	yield takeLatest(eFoCaAnTruongActionTypeIds.LOAD_CAAN_START, loadFoCaAnWorker)
	yield takeEvery(eFoCaAnTruongActionTypeIds.SAVE_START, saveFoCaAnTruongWorker)
	yield takeEvery(eFoCaAnTruongActionTypeIds.DELETE_START, deleteFoCaAnTruongWorker)
}

function* loadFoCaAnTruongWorker(action: IFoCaAnTruongLoadStart): any {
	const res: IBaseResponeModel = yield call([foCaAnTruongApi, foCaAnTruongApi.SelectByCoSo], action.payload)
	if (res.is_success) {
		yield put(foCaAnTruongActions.loadFoCaAnTruongSuccess(res.data || []))
	} else {
		yield put(foCaAnTruongActions.loadFoCaAnTruongError(res.message || "Không tải được danh sách ca ăn theo trường"))
	}
}

function* loadFoCaAnWorker(): any {
	const res: IBaseResponeModel = yield call([foCaAnApi, foCaAnApi.SelectAll])
	if (res.is_success) {
		yield put(foCaAnTruongActions.loadFoCaAnSuccess(res.data || []))
	} else {
		yield put(foCaAnTruongActions.loadFoCaAnError(res.message || "Không tải được danh sách ca ăn"))
	}
}

/**
 * `PUT food/ca-an-truong` nhận nguyên danh sách `dm_truong_ids` rồi tự thêm/huỷ đăng ký,
 * nên cả thêm mới lẫn cập nhật đều gọi Update (giống adm).
 */
function* saveFoCaAnTruongWorker(action: IFoCaAnTruongSaveStart): any {
	const is_update = action.payload.id > 0;
	const res: IBaseResponeModel = yield call([foCaAnTruongApi, foCaAnTruongApi.Update], action.payload);
	if (res.is_success) {
		yield put(foCaAnTruongActions.saveFoCaAnTruongSuccess(is_update))
	} else {
		yield put(foCaAnTruongActions.saveFoCaAnTruongError(res.message || "Không lưu được ca ăn"))
	}
}

/** Xoá 1 ca ăn = xoá toàn bộ dòng fo_caan_truong của ca ăn đó trong cơ sở đang chọn */
function* deleteFoCaAnTruongWorker(action: IFoCaAnTruongDeleteStart): any {
	for (const id of action.payload) {
		const res: IBaseResponeModel = yield call([foCaAnTruongApi, foCaAnTruongApi.Delete], id)
		if (!res.is_success) {
			yield put(foCaAnTruongActions.deleteFoCaAnTruongError(res.message || "Không xóa được ca ăn"))
			return;
		}
	}
	yield put(foCaAnTruongActions.deleteFoCaAnTruongSuccess())
}
